import React from "react"




const CoverImage = (props) => (
    <div className="cover-image-container">
        <div className="rgba-black-strong zoom"></div>
        <img 
            src={props.image}
            className="img-fluid cover-image" 
            alt="cover"
        />
        <h2 className="cover-image-title h2-responsive">{props.text}</h2>
    </div>

)

export default CoverImage;